import Box from '@mui/material/Box'
import type { SignalProviderVerifiedStatus } from '@brushfire/types'
import {
  VERIFIED_STATUS_PILL_STYLES,
  formatVerifiedStatusLabel,
} from '../lib/signal-provider-status'

interface Props {
  status: SignalProviderVerifiedStatus
  size?: 'default' | 'compact'
}

export function SignalProviderVerifiedPill({ status, size = 'default' }: Props) {
  const style = VERIFIED_STATUS_PILL_STYLES[status]
  const compact = size === 'compact'
  return (
    <Box
      component="span"
      data-testid={`signal-provider-verified-pill-${status}`}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: compact ? '19px' : '24px',
        px: compact ? '8px' : 1,
        borderRadius: compact ? '10px' : '100px',
        border: compact ? `0.5px solid ${style.border}` : `1px solid ${style.border}`,
        bgcolor: style.bg,
        color: style.color,
        fontSize: compact ? '10px' : '12px',
        fontWeight: 500,
        lineHeight: compact ? '16px' : '16px',
        whiteSpace: 'nowrap',
      }}
    >
      {formatVerifiedStatusLabel(status)}
    </Box>
  )
}
